import { render, staticRenderFns } from "./coachesLessons.vue?vue&type=template&id=16bc1ff6&scoped=true"
import script from "./coachesLessons.vue?vue&type=script&lang=js"
export * from "./coachesLessons.vue?vue&type=script&lang=js"
import style0 from "./coachesLessons.vue?vue&type=style&index=0&id=16bc1ff6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bc1ff6",
  null
  
)

export default component.exports